module.exports = __webpack_public_path__ + "img/extra-features.bc5ab82c.png";